import type { PropsWithChildren } from "react";
import type { SwitchProps } from "@headlessui/react";
import { Switch } from "@headlessui/react";
import { tv } from "tailwind-variants";

import { focusRing } from "./interaction";

const toggleVariants = tv({
  slots: {
    container: [
      "group peer inline-flex h-8 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent",
      "transition-colors",
      focusRing,
      "disabled:cursor-not-allowed disabled:opacity-50",
    ],
    switch:
      "pointer-events-none block size-6 rounded-full bg-white shadow-sm ring-1 ring-black/10 transition-transform",
  },
  variants: {
    checked: {
      true: { container: "bg-accent hover:bg-accent-hover", switch: "translate-x-6.5" },
      false: { container: "bg-surface-muted hover:bg-line-strong", switch: "translate-x-0.5" },
    },
  },
});

const { container, switch: switchClass } = toggleVariants();

export type ToggleProps = SwitchProps<"button">;

export const Toggle = ({ checked, ...props }: PropsWithChildren<ToggleProps>) => {
  return (
    <Switch checked={checked} className={container({ checked })} {...props}>
      <div className={switchClass({ checked })} />
    </Switch>
  );
};
